import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { OrdersAutomationConfig } from "./automationConfigApi";
import { getOrdersConfig, updateOrdersConfig } from "./automationConfigApi";

export const useOrderAutomationConfig = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ["automation-settings", "orders"],
    queryFn: ({ signal }) => getOrdersConfig(signal),
  });

  const updateMutation = useMutation<OrdersAutomationConfig, unknown, OrdersAutomationConfig>({
    mutationFn: (v) => updateOrdersConfig(v),
    onSuccess: async (data) => {
      enqueueSnackbar("Ustawienia dla zamówień zostały zaktualizowane", { variant: "success" });
      queryClient.setQueryData(["automation-settings", "orders"], data);
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się zaktualizować ustawień dla zamówień. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return { isLoading, data, updateSettings: (config: OrdersAutomationConfig) => updateMutation.mutateAsync(config) };
};
